module.exports = __webpack_public_path__ + "img/sketch.dd890f20.svg";